import { render, staticRenderFns } from "./LossesReport.vue?vue&type=template&id=98fd5900&scoped=true&"
import script from "./LossesReport.vue?vue&type=script&lang=ts&"
export * from "./LossesReport.vue?vue&type=script&lang=ts&"
import style0 from "./LossesReport.vue?vue&type=style&index=0&id=98fd5900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98fd5900",
  null
  
)

export default component.exports